@if (label) {
  <label class="py-1">
    {{ label }}
    @if (!!infoText && infoText.length > 0) {
      <fa-icon class="infoIcon"
               [icon]="faInfo"
               [title]="infoText"
               data-cy="sonderfall-multi-info"
      ></fa-icon>
    }
  </label>
}

@for (option of options; track option.value) {
  @if (option.value) {
    <div class="form-check sfk-form-vertical-spacer mb-1"
         [ngClass]="{'form-check-disabled' : readonly, 'form-check-active' : !readonly}"
         [attr.data-cy]="'sonderfall-checkbox-' + option.value">
      <label class="form-check-label">
        {{ option.name }}
        <input
          class="form-check-input mx-2"
          type="checkbox"
          [checked]="isSelected(option.value)"
          [disabled]="readonly"
          (change)="toggle(option.value, $any($event.target).checked)"
        />
      </label>
      @if (option.info && option.info.length > 0) {
        <p class="ms-4 mt-1 text-muted sonderfall-info">
          <small [innerHTML]="option.info | safeHtml"></small>
        </p>
      }
    </div>

    @if (isSelected(option.value)) {
      <div class="ms-4 mb-3" [formGroup]="getEntry(option.value)" [attr.data-cy]="'sonderfall-form-section-' + option.value">
        @if (isSonstiges(option.value)) {
          <app-textarea
            id="begruendung"
            [rows]="3"
            [customFormGroup]="getEntry(option.value)"
            [label]="begruendungLabel"
            [readonly]="readonly"
            [attr.data-cy]="'sonderfall-begruendung-' + option.value"
          ></app-textarea>
        }
        @if (getEntry(option.value).get('id')?.value) {
          <app-ticket-antrag-sidebar-attachments
            [antragTicketId]="antragTicketId"
            [sonderfallId]="getEntry(option.value).get('id')?.value"
            [attachmentTypeFilter]="AttachmentType.SONDERFALLNACHWEIS"
            [deleteable]="deleteable"
            [appendable]="appendable"
            [required]="isNachweisRequired(option.value)"
            [allowedTypesForSelection]="allowedTypesForSelection"
          ></app-ticket-antrag-sidebar-attachments>
        } @else if (isNachweisRequired(option.value)) {
          <div class="text-muted small py-1" data-cy="sonderfall-nachweis-save-hint">
            {{ 'TICKETDETAIL.SONDERFALL.NACHWEIS_NACH_SPEICHERN' | translate }}
          </div>
        } @else {
          <!-- Ohne Nachweispflicht ist der Upload nur eine Möglichkeit, keine offene Forderung -
               entsprechend zurückhaltend formuliert. -->
          <div class="text-muted small py-1" data-cy="sonderfall-nachweis-save-hint-optional">
            {{ 'TICKETDETAIL.SONDERFALL.NACHWEIS_NACH_SPEICHERN_OPTIONAL' | translate }}
          </div>
        }
      </div>
    }
  }
}
